<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <ModalFacilitador
        :typeForm="typeForm"
        :facilitador="facilitador"
        :activarModal="activarModal"
        :cambioForm="cambioForm"
        @listarFacilitadores="getFacilitadores"
      ></ModalFacilitador>

      <div class="row justify-content-center">
        <div class="col-lg-12">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-12"
            body-classes="px-lg-12 py-lg-12"
            class="border-0"
          >
            <h2 style="float:left">Listado de facilitadores</h2>

            <base-button
              type="primary"
              icon="ni ni-fat-add"
              size="lg"
              @click="crearForm"
              style="float:right;margin-botton:12px"
              >Crear facilitador</base-button
            >
            <table
              class="table table-bordered table-dark"
              style="margin-top: 60px;"
            >
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Apellido</th>
                  <th scope="col">Cédula</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Correo</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(facilitador, index) in facilitadores" :key="index">
                  <td v-text="facilitador.nombre"></td>
                  <td v-text="facilitador.apellido"></td>
                  <td v-text="facilitador.cedula"></td>
                  <td v-text="facilitador.telefono"></td>
                  <td v-text="facilitador.correo"></td>
                  <td
                    style="display:inline-flex;border-top:none;border-right:none"
                  >
                    <base-button
                      type="warning"
                      icon="ni ni-settings"
                      size="sm"
                      @click="editarForm(facilitador)"
                    ></base-button>
                    <base-button
                      type="danger"
                      icon="ni ni-fat-delete"
                      size="sm"
                      @click="eliminarFacilitador(facilitador)"
                    ></base-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ModalFacilitador from "./components/ModalFacilitador";
export default {
  components: {
    ModalFacilitador,
  },
  data() {
    return {
      facilitadores: [],
      typeForm: "",
      facilitador: [],
      activarModal: false,
      cambioForm: "",
      messageSuccess: null
    };
  },
  created() {
    this.getFacilitadores();
  },
  methods: {
    async getFacilitadores() {
      this.activarModal = false;
      try {
        const { data } = await this.$api.get("facilitators");
        this.facilitadores = data.data;
      } catch (error) {
        console.log("hubo un error al cargar los facilitadores");
      }
    },
    crearForm() {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Crear";
    },
    async editarForm(facilitador) {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Editar";
      this.facilitador = facilitador;
    },
    async eliminarFacilitador(facilitador) {
      var url = "facilitators/" + facilitador.id;
      var method = "delete";

      try {
        await this.$api({
          url: url,
          method: method,
        });
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          console.log(e);
        }
      }
      this.getFacilitadores();
    },
  },
  watch: {
    /*modalActive: function (val) {
      if (this.typeForm === 'Crear') {
        this.typeForm = 'Editar'        
      }else{
        this.typeForm = 'Crear';
      }
    }*/
  },
};
</script>
